import RoleDashboardLayout from '../../components/RoleDashboardLayout';
import { ExportCenterContent } from '../../components/accountant/ExportCenterContent';

export default function StaffExportCenterPage() {
  return (
    <RoleDashboardLayout role="accountant">
      <ExportCenterContent />
    </RoleDashboardLayout>
  );
}